import { HttpClient, HttpParams, HttpParameterCodec, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import {map} from 'rxjs/operators';
import {MultipartResponseResult} from '../Versand/VersandUI';
import {Austausch} from '../../../Main/Pages/Austausch/Austausch';

class UserInfoData {
  Name: string = "";
  Role: string = "";
  Rights: string[] = [];
}

export enum Rights{
  GroupAdministration,
  UserAdministration,
  ClientAdministration,
  FactoringView,
  TeamsView,
  Status,
  Abbrechnung,
  Absetzung,
  ChangeDevices,
  ReportEditing,
  GeraeteHistorie,
  VersandHistorie,
  AllowPatientMerge,
  AkteGenehmigung,
  AkteGeraet,
  AkteLeitstelle,
  AkteVersand,
  AkteRuekholung,
  AkteEkv,
  AkteBeendigung,
  AkteAbrechnung,
  AkteWellcomeCall,
  AkteDateien,
  Patenten,
  AkteAuftraegeAktive,
  AkteAuftraegeVergangen,
  PatentenKontakte,
  AkteAnzeigen,
  CreateCompanyEntrys
}

export enum ReadWrite{
  ReadOnly,
  ReadWrite,
}

export enum StatusRights
{
  S_999InKlaerung = -999,
  S_2LeadsQC= -2,
  S_1Gesamt= -1,
  S0Neu = 0,
  S1Postversand = 1,
  S20Ekv = 20,
  S26Welcomcall = 26,
  S30Leitstelle = 30,
  S40Versand = 40,
  S50Inbr = 50,
  S55UnterschriftWartend = 55,
  S200InBetrieb = 200,
  S800Ruekholung = 800,
  S999Beendet = 999,
  S100Austausch = 100
}

class WebUser {

  Name: string = "";
  Rolle: string = "";
  Token: string = "";
  Rights: string[] = [];
  get AdminOnly(): boolean {
    return this.Rolle == "Admin";
  }

  HasRight(right: Rights, overrideCheck: boolean = false): boolean {

    return this.HasRightWithSubRight(right, null, overrideCheck);
  }

  HasRightWithSubRight(right: Rights, subRight: number|null , overrideCheck: boolean = false): boolean {

    if(subRight != null)
      return this.AdminOnly || this.Rights.includes(`r${right}_${subRight}`) || overrideCheck;
    return this.AdminOnly || this.Rights.filter(s => s.includes(`r${right}_`) || s == `r${right}`).length > 0 || overrideCheck;
  }


  get HatVolleBerechtigung(): boolean {
    return this.Rolle == "Admin" || this.Rolle == "Sachbearbeiter";
  }

  get HatSupervisorBerechtigung(): boolean {
    return this.Rolle == "Admin" || this.Rolle == "Sachbearbeiter" || this.Rolle == "Supervisor" || this.Rolle == "Management";
  }

  get HatManagementBerechtigung(): boolean {
    return this.Rolle == "Admin" || this.Rolle == "Sachbearbeiter" || this.Rolle == "Management";
  }


  get HatSpezialUserBerechtigung(): boolean {
    return this.Rolle == "Admin" || this.Rolle == "Sachbearbeiter" || this.Rolle == "Supervisor" || this.Rolle == "Management" || this.Rolle == "SpezialUser";
  }

  get HatWelcomeCallBerechtigung(): boolean {
    return this.Rolle == "Admin" || this.Rolle == "Sachbearbeiter" || this.Rolle == "Supervisor"  || this.Rolle == "Management" || this.Rolle == "SpezialUser" || this.Rolle == "WelcomeCall";
  }

  get HatWelcomeCallBerechtigungWithoutSpezialUser(): boolean {
    return this.Rolle == "Admin" || this.Rolle == "Sachbearbeiter" || this.Rolle == "Supervisor"  || this.Rolle == "Management" || this.Rolle == "WelcomeCall";
  }


  protected decodeBase64ToObject<T>(base64String: string): T {
    // 1. Base64 zu UTF-8 String dekodieren
    const jsonString = atob(base64String);
    console.log(jsonString);
    // 2. JSON-String in Objekt umwandeln
    return JSON.parse(jsonString) as T;
  }

  SetToken(token: string, Data: string) {
    if (token !== '') {
      console.log(token);
      this.Token = token;
      var data = this.decodeBase64ToObject<UserInfoData>(Data)
      console.log(data);
      this.Name = data.Name;
      this.Rolle = data.Role;
      this.Rights = data.Rights;
    }
  }

}

export class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}


export class RestClient {
  private http = inject(HttpClient);
  Get<T>(url: string): Promise<T> {
    return new Promise<T>(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }

      this.http.get<T>(url, { headers }).subscribe({
        next: (config) => {
          res(config);
        },
        error: (err) => {

          if(err.status == 401)
            window.location.href ='/login?qr=' + btoa(window.location.pathname);

          res(undefined as unknown as T);
        },
      });
    });
  }

  GetFile(url: string): Promise<HttpResponse<Blob>> {
    return new Promise<HttpResponse<Blob>>(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }

      this.http.get(url, {
        headers, responseType: 'blob',
        observe: 'response' }).subscribe({
        next: (config) => {
          res(config);
        },
        error: (err) => {

          rej(err);
        },
      });
    });
  }

  Post<T, T2>(url: string, payload: T2): Promise<T> {
    return new Promise<T>(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }

      this.http.post<T>(url, payload,{ headers }).subscribe({
        next: (config) => {
          res(config);
        },
        error: (err) => {
          rej(err);
        },
      });
    });
  }

  PostMultipart<T, T2>(url: string, payload: T2): Promise<MultipartResponseResult<T>> {
    return new Promise<MultipartResponseResult<T>>(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }

      this.http.post(url, payload,{ headers, observe: 'response', responseType: 'arraybuffer' }).pipe(
        map(response => {
          // Content-Type Header auslesen (z.B. "multipart/mixed; boundary=----WebKitFormBoundary...")
          const contentType = response.headers.get('content-type') || '';

          // Boundary per Regex aus dem Header extrahieren
          const boundaryMatch = contentType.match(/boundary=(?:"([^"]+)"|([^;]+))/i);
          const boundary = boundaryMatch ? (boundaryMatch[1] || boundaryMatch[2]) : null;

          if (!boundary) {
            throw new Error('Keine Boundary im Content-Type-Header der Server-Antwort gefunden.');
          }

          // Den empfangenen ArrayBuffer an den Byte-Parser übergeben
          const arrayBuffer = response.body as ArrayBuffer;
          return this.parseMultipartResponse<T>(arrayBuffer, boundary);
        })
      ).subscribe({
        next: (config) => {
          res(config);
        },
        error: (err) => {

          rej(err);
        },
      });
    });
  }
   indexOfBytes(data: Uint8Array, pattern: Uint8Array, startIndex = 0): number {
    for (let i = startIndex; i <= data.length - pattern.length; i++) {
      let found = true;
      for (let j = 0; j < pattern.length; j++) {
        if (data[i + j] !== pattern[j]) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
    return -1;
  }

  private parseMultipartResponse<T>(buffer: ArrayBuffer, boundaryRaw: string): MultipartResponseResult<T> {
    const bytes = new Uint8Array(buffer);
    const encoder = new TextEncoder();
    const decoder = new TextDecoder('utf-8');

    // Boundary bereinigen (führende '-' entfernen, um ein klares Pattern zu haben)
    const cleanBoundary = boundaryRaw.replace(/^-+/, '');

    // Wir suchen nach der Boundary im Byte-Stream
    let jsonData = {} as T;
    let fileBlob = new Blob();
    let fileName = 'download.dat';

    // Hilfsfunktion zum Dekodieren eines Byte-Abschnitts als Text
    const textContent = decoder.decode(bytes);

    // Split-Logik für Text-Header vs. Binary-Body:
    // Wir suchen die Indizes der Parts dynamisch
    const boundaryPattern = new RegExp(`-+${cleanBoundary.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`);

    // Wir teilen den Text/Byte-Stream anhand der Boundary-Schnittstellen
    // Für Live-Systeme: Wir prüfen CRLF (\r\n) und LF (\n)

    // 1. Positionen aller Boundaries im ArrayBuffer finden
    const boundaryPositions: number[] = [];
    const searchPattern = encoder.encode(cleanBoundary);

    for (let i = 0; i <= bytes.length - searchPattern.length; i++) {
      let match = true;
      for (let j = 0; j < searchPattern.length; j++) {
        if (bytes[i + j] !== searchPattern[j]) {
          match = false;
          break;
        }
      }
      if (match) {
        // Zurückgehen, um eventuelle führende '-' mitzunehmen
        let start = i;
        while (start > 0 && bytes[start - 1] === 45) { // 45 = '-'
          start--;
        }
        boundaryPositions.push(start);
        i += searchPattern.length;
      }
    }

    // Iteration durch die gefundenen Parts
    for (let i = 0; i < boundaryPositions.length - 1; i++) {
      const partStart = boundaryPositions[i];
      const partEnd = boundaryPositions[i + 1];
      const partBytes = bytes.subarray(partStart, partEnd);

      // Suche nach Trenner zwischen Header und Body (\r\n\r\n oder \n\n)
      let headerEnd = this.indexOfBytes(partBytes, encoder.encode('\r\n\r\n'));
      let headerSeparatorLength = 4;

      if (headerEnd === -1) {
        // Fallback für Systeme, die \n\n nutzen
        headerEnd = this.indexOfBytes(partBytes, encoder.encode('\n\n'));
        headerSeparatorLength = 2;
      }

      if (headerEnd === -1) continue;

      // Header dekodieren
      const headerStr = decoder.decode(partBytes.subarray(0, headerEnd));

      // Body-Bytes ausschneiden (ab Ende der Header-Trennzeile)
      let bodyBytes = partBytes.subarray(headerEnd + headerSeparatorLength);

      // Trailing \r\n oder \n vor der nächsten Boundary entfernen
      if (bodyBytes.length >= 2 && bodyBytes[bodyBytes.length - 2] === 13 && bodyBytes[bodyBytes.length - 1] === 10) {
        bodyBytes = bodyBytes.subarray(0, bodyBytes.length - 2);
      } else if (bodyBytes.length >= 1 && bodyBytes[bodyBytes.length - 1] === 10) {
        bodyBytes = bodyBytes.subarray(0, bodyBytes.length - 1);
      }

      // --- Typen unterscheiden ---
      if (headerStr.toLowerCase().includes('application/json')) {
        let jsonStr = decoder.decode(bodyBytes).trim();
        // Säubern falls noch Rest-Dashes vorhanden sind
        jsonStr = jsonStr.replace(/^-+/, '').replace(/-+$/, '').trim();

        if (jsonStr) {
          try {
            jsonData = JSON.parse(jsonStr) as T;
          } catch (e) {
            console.log("JSON Parsing fehlgeschlagen:", jsonStr);
          }
        }
      } else if (headerStr.toLowerCase().includes('content-disposition') || headerStr.toLowerCase().includes('application/pdf')) {
        // Dateinamen extrahieren
        const nameMatch = headerStr.match(/filename="?([^";\r\n]+)"?/i);
        if (nameMatch && nameMatch[1]) {
          fileName = nameMatch[1].trim();
        }

        // Content-Type extrahieren
        const typeMatch = headerStr.match(/Content-Type:\s*([^\r\n;]+)/i);
        const contentType = typeMatch ? typeMatch[1].trim() : 'application/zip';

        fileBlob = new Blob([bodyBytes], { type: contentType });
      }
    }

    return { jsonData, fileBlob, fileName };
  }



  Put<T, T2>(url: string, payload: T2): Promise<T> {
    return new Promise<T>(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }

      this.http.put<T>(url, payload, { headers }).subscribe({
        next: (config) => {
          res(config);
        },
        error: (err) => {
          rej(err);
        },
      });
    });
  }

  PostForCSV(url: string, payload: any): Promise<string> {
    var payloadForm = new HttpParams();

    Object.keys(payload).forEach(k => {
      payloadForm = payloadForm.set(k, payload[k]);
    })

    return new Promise<string>(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }

      this.http.post(url, payloadForm, { headers, responseType: 'text' }).subscribe({
        next: (config) => {
          res(config?.toString());
        },
        error: (err) => {
          rej(err);
        },
      });
    });
  }

  PostFile<T>(url: string, payload: File): Promise<T> {
    return new Promise<T>(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }
      // FormData ist das Standard-Format für File-Uploads
      const formData = new FormData();

      // 'file' ist der Key, den dein Backend (z.B. C# IFormFile) erwartet
      formData.append("file", payload, payload.name);
      this.http.post<T>(url, formData, { headers }).subscribe({
        next: (config) => {
          res(config);
        },
        error: (err) => {

          rej(err);
        },
      });
    });
  }

  Delete(url: string): Promise<null> {
    return new Promise(async (res, rej) => {
      const headers = { 'Authorization': "Bearer " + await this.GetTocken() }

      this.http.delete(url, { headers }).subscribe({
        next: (config) => {
          res(null);
        },
        error: (err) => {
          rej(err);
        },
      });
    });
  }

  constructor(){
  }

  GetTocken(): Promise<string> {
    return new Promise<string>((res, rej) => {

      this.http.get<UserInfo>("/GetUserInfo").subscribe({
        next: (config) => {
          User.SetToken(config?.tocken ?? "", config?.infoData ?? "");
          res(config?.tocken);
        },
        error: (err) => {
          rej(err);
        },
      });
    });
  }
}

export interface UserInfo {
  tocken: string;
  infoData: string;
}



export const User: WebUser = new WebUser();
